// src/components/user/tabs/OrganizationAccessTab.jsx
import React from 'react';

function OrganizationAccessTab({
  allOrgs,
  assignedOrgs,
  selectedOrgIds,
  setSelectedOrgIds,
  handleAssign,
  handleRemove
}) {
  return (
    <div className="row">
      <div className="col-md-5">
        <h6>All Organizations</h6>
        <select
          className="form-select"
          multiple
          size="10"
          value={selectedOrgIds}
          onChange={(e) =>
            setSelectedOrgIds(Array.from(e.target.selectedOptions).map(opt => opt.value))
          }
        >
          {allOrgs.map(org => (
            <option key={org.id} value={org.id}>{org.org_name}</option>
          ))}
        </select>
      </div>

      <div className="col-md-2 d-flex align-items-center justify-content-center">
        <button className="btn btn-primary" onClick={handleAssign}>&gt;&gt;</button>
      </div>

      <div className="col-md-5">
        <h6>Assigned Organizations</h6>
        <ul className="list-group">
          {assignedOrgs.map(org => (
            <li key={org.id} className="list-group-item">
              {org.org_name}
              <button
                className="btn btn-sm btn-danger float-end"
                onClick={() => handleRemove(org.id)}
              >
                &lt;&lt;
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default OrganizationAccessTab;
